<template>
  <div class="option-modal">
    <div
      :id="`${item.key}-filter`"
      :class="[
        'nav-button',
        `container-${item.key}`,
        item.active ? 'active' : '',
      ]"
      @click="toggleOptions()"
    >
      <div class="flex-row flex-1 just-between align-center">
        <div class="white-f-16">
          {{ getLabel(item.label, item.activeOption, item.active) }}
        </div>
        <img
          src="@shared/assets/img/general/chevron-white-down.png"
          class="img-size-24"
        >
      </div>
    </div>
    <div
      :class="[
        'options',
        (!loading && show) ? 'show-options' : '', `hide-${item.key}`,
        checkIfOnEdge(),
      ]"
    >
      <div class="flex-center-column">
        <div class="sac__font-14 semi-bold">
          {{ item.label }}
        </div>
        <button
          class="sac__font-14 f-primary semi-bold"
          @click="clearOptions(item.key)"
        >
          Clear
        </button>
      </div>
      <div
        v-if="item.key !== 'techs'"
        class="flex-row align-center"
      >
        <button
          v-for="(option, idx) in item.options"
          :key="idx"
          :class="[
            isOptionActive(item.activeOption, option) ? 'active' : '',
            'select-button',
          ]"
          @click="selectOption(option, item.key)"
        >
          <div class="f-16">
            {{ option.label }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TechniciansFilterOption',
  props: {
    item: {
      type: Object,
    },
    loading: Boolean,
    change: Function,
    clear: Function,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    document.querySelector(`:not(.hide-${this.item.key})`).addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(`:not(.hide-${this.item.key})`).removeEventListener('click', this.closeOnClick);
  },
  methods: {
    selectOption(option, key) {
      this.change(option, key);
      this.show = false;
    },
    clearOptions(key) {
      this.clear(key);
      this.show = false;
    },
    toggleOptions() {
      if (!this.loading) {
        this.show = true;
      }
    },
    getLabel(label, activeOption, isActive) {
      let val = label;
      if (isActive && Array.isArray(activeOption)) {
        if (activeOption.length === 1) {
          val = activeOption[0].label;
        } else if (activeOption.length > 1) {
          val = `${activeOption[0].label} (+${activeOption.length})`;
        }
      } else if (isActive && label === 'Urgent') {
        val = 'Urgent';
      } else if (isActive) {
        val = activeOption.label;
      }
      return val;
    },
    isOptionActive(activeOption, option) {
      return activeOption.value === option.value;
    },
    closeOnClick(e) {
      if (!e.target.closest(`.container-${this.item.key}`) && !e.target.closest(`.hide-${this.item.key}`) && this.show) {
        this.show = false;
      }
    },
    checkIfOnEdge() {
      const filter = document.getElementById(`${this.item.key}-filter`);
      if (filter) {
        const {
          x,
        } = filter.getBoundingClientRect();
        if (window.innerWidth - x < 200) {
          return 'right-popup';
        }
        if (x < 200) {
          return 'left-popup';
        }
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>

.option-modal {
  position: relative;
  flex: 1;
}

.nav-button {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 10px;
  height: 44px;
  cursor: pointer;
  padding: 0 15px;
  background-color: $N95;
  border-radius: 6px;

  &.active {
    background-color: $NBLUE110;
  }

  &:hover {
    background-color: $N90;
  }

  @media (max-width: 850px) {
    height: 36px;
  }
}

.options {
  display: none;
  position: absolute;
  background-color: $WHITE;
  width: auto !important;
  top: 60px;
  left: -10px;
  padding: 7px 16px 7px 16px;
  box-shadow: 0 3px 6px rgba(9, 15, 32, 0.07);
  border-radius: 6px;
  white-space: nowrap;
  z-index: 3;

  @media(max-width: 850px) {
    left: -75px;
  }

  &:hover {
    display: block;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-bottom-color: $WHITE;
    border-top: 0;
    margin-left: -8px;
    margin-top: -8px;
  }

  &.show-options {
    display: grid;
    padding: 24px;
    gap: 20px;

    @media(max-width: 850px) {
      width: 250px;
      padding: 16px;

      .f-16 {
        font-size: 0.75em;
      }
    }
  }

  &.right-popup {
    left: -235px;

    &:after {
      left: 80%;
    }

    @media (max-width: 850px) {
      left: -155px;
    }
  }
}

.select-button {
  &:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  &:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
</style>
